import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { featureDescription } from "../../../constants";

const useStyles = makeStyles((theme) => ({
  noChanges: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  changesList: {
    minWidth: 300,
  },
  addedFeature: {
    color: theme.palette.success.main,
  },
  removedFeature: {
    color: theme.palette.error.main,
  },
}));

export const FeatureChangesModal = ({
  open,
  onClose,
  onConfirm,
  currentFeatures,
  newFeatures,
}) => {
  const classes = useStyles();

  const addedFeatures = newFeatures.filter(
    (feature) => !currentFeatures.includes(feature)
  );
  const removedFeatures = currentFeatures.filter(
    (feature) => !newFeatures.includes(feature)
  );
  const hasChanges = addedFeatures.length > 0 || removedFeatures.length > 0;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Review Feature Changes</DialogTitle>
      <DialogContent>
        {!hasChanges ? (
          <div className={classes.noChanges}>
            <Typography>No changes to apply</Typography>
          </div>
        ) : (
          <List className={classes.changesList}>
            {addedFeatures.map((feature) => (
              <ListItem key={`added-${feature}`}>
                <ListItemIcon className={classes.addedFeature}>
                  <AddIcon />
                </ListItemIcon>
                <ListItemText
                  primary={feature}
                  secondary={featureDescription[feature]}
                  className={classes.addedFeature}
                />
              </ListItem>
            ))}
            {removedFeatures.map((feature) => (
              <ListItem key={`removed-${feature}`}>
                <ListItemIcon className={classes.removedFeature}>
                  <RemoveIcon />
                </ListItemIcon>
                <ListItemText
                  primary={feature}
                  secondary={featureDescription[feature]}
                  className={classes.removedFeature}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={!hasChanges}
        >
          Confirm Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
